import { render, staticRenderFns } from "./Select-Customer.vue?vue&type=template&id=bcffc7b6&scoped=true"
import script from "./Select-Customer.vue?vue&type=script&lang=js"
export * from "./Select-Customer.vue?vue&type=script&lang=js"
import style0 from "./Select-Customer.vue?vue&type=style&index=0&id=bcffc7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcffc7b6",
  null
  
)

export default component.exports